// extracted by mini-css-extract-plugin
module.exports = {"confirmationText":"clear-stage-modal_confirmationText__195Kx","noteText":"clear-stage-modal_noteText__E_x1M"};